import { useEffect, useRef } from 'react'
import { useTheme } from '../../../theme/useTheme'

export default function CalcomButton() {
  const { theme } = useTheme()
  const cancelledRef = useRef(false)

  useEffect(() => {
    cancelledRef.current = false

    void (async () => {
      try {
        const { getCalApi } = await import('@calcom/embed-react')
        const cal = await getCalApi({
          namespace: '30min',
          embedJsUrl: 'https://booking.strangeways.co/embed/embed.js',
        })

        if (cancelledRef.current) return

        cal('ui', {
          cssVarsPerTheme: {
            light: { 'cal-brand': '#1a1d3f' },
            dark: { 'cal-brand': '#f5f7ff' },
          },
          hideEventTypeDetails: false,
          layout: 'month_view',
          theme: theme,
        })
      } catch (error) {
        console.error('Failed to load booking.strangeways.co embed', error)
      }
    })()

    return () => {
      cancelledRef.current = true
    }
  }, [theme])

  return (
    <button
      data-cal-namespace="30min"
      data-cal-link="studio/30min"
      data-cal-origin="https://booking.strangeways.co"
      data-cal-config='{"layout":"month_view", theme: theme}'
      className="text-sm inline-flex cursor-pointer items-center gap-2 rounded-md bg-gray-800 px-3 py-1.5 text-white shadow-subtle transition-colors hover:bg-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-500/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 dark:bg-gray-500 dark:hover:bg-gray-400"
    >
      Book a free consultation
    </button>
  )
}
